import axios from '@/utils/request'

export default {
  // 2020-12-15
  search(params) {
    return axios.get('/sizes', params)
  },
  // 2020-07-29
  findByName(params) {
    return axios.get('/sizes/find-by-name', params)
  },
  // 2020-07-29
  findByTenantId() {
    return axios.get('/sizes/find-by-tenant-id')
  },
  // 2020-07-30
  update(id, params) {
    return axios.put('/sizes/' + id, params)
  },
  // 2020-12-16
  updateCategory(id, params) {
    return axios.put('/sizes/' + id + '/update-category', params)
  },
  // 2021-01-20
  batchUpdateCategory(params) {
    return axios.put('/sizes/batch-update-category', params)
  },
  // 2020-12-31
  swapSequence(params) {
    return axios.put('/sizes/swap-sequence', params)
  },
  // 2020-07-30
  insertBatch(params) {
    return axios.post('/sizes/insert-batch', params)
  },
  // 2021-03-31
  findBySequence(params) {
    return axios.get('/suppliers/find-by-sequence', params)
  },
  // 2020-07-30
  delete(id) {
    return axios.delete('/sizes/' + id)
  }

}

